import type { SettingsParamsType } from '@econtractor/types';
import vconst from 'utils/helpers/structs/vconst';

/** Finished object is locked for edits only when company setting is on. */
export const isObjectEditLocked = (
    objectStatus: number | string | null | undefined,
    params?: Pick<SettingsParamsType, 'lockFinishedObject'> | null,
): boolean =>
    Boolean(params?.lockFinishedObject) && Number(objectStatus) === vconst.objectFinished;
